export default __webpack_public_path__ + "static/main-pic-68043f7e0b9a77d65db913dd43a9da06.png";